package com.xtream.composeapp.viewmodel

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.data_kmp.dto.DeviceStatusResponse
import com.xtream.data_kmp.dto.PlaylistsResponse
import com.xtream.data_kmp.dto.RegisterDeviceResponse
import com.xtream.data_kmp.remote.repo.DeviceInfo
import com.xtream.data_kmp.remote.repo.PlayerServerRepo
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

class PlayerServerViewModel(
    private val playerServerRepo: PlayerServerRepo
) : ViewModel() {

    var playlistState by mutableStateOf<ApiSealed<PlaylistsResponse>>(ApiSealed.Initial)
    var deviceStatusState by mutableStateOf<ApiSealed<DeviceStatusResponse>>(ApiSealed.Initial)
    var registerState by mutableStateOf<ApiSealed<RegisterDeviceResponse>>(ApiSealed.Initial)

    private val coroutineExceptionHandler = CoroutineExceptionHandler { _, throwable ->
        throwable.printStackTrace()
    }

    fun loadPlaylist(deviceInfo: DeviceInfo) {
        playlistState = ApiSealed.Loading
        viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            playerServerRepo.loadPlaylists(
                baseUrl = SharedBuildKonfig.PLAYER_SERVER,
                apiKey = SharedBuildKonfig.PLAYER_SERVER_API_KEY,
                deviceInfo = deviceInfo,
                onSuccess = { playlistState = ApiSealed.Success(it) },
                onFail = { playlistState = ApiSealed.Error(it.message ?: "Unknown error") }
            )
        }
    }

    fun checkStatus(deviceInfo: DeviceInfo) {
        deviceStatusState = ApiSealed.Loading
        viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            playerServerRepo.checkStatus(
                baseUrl = SharedBuildKonfig.PLAYER_SERVER,
                apiKey = SharedBuildKonfig.PLAYER_SERVER_API_KEY,
                deviceInfo = deviceInfo,
                onSuccess = { deviceStatusState = ApiSealed.Success(it) },
                onFail = { deviceStatusState = ApiSealed.Error(it.message ?: "Unknown error") }
            )
        }
    }

    fun registerDevice(deviceInfo: DeviceInfo) {
        registerState = ApiSealed.Loading
        viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            playerServerRepo.registerDevice(
                baseUrl = SharedBuildKonfig.PLAYER_SERVER,
                apiKey = SharedBuildKonfig.PLAYER_SERVER_API_KEY,
                deviceInfo = deviceInfo,
                onSuccess = { registerState = ApiSealed.Success(it) },
                onFail = { registerState = ApiSealed.Error(it.message ?: "Unknown error") }
            )
        }
    }



    fun editPlaylist(
        playlistId: String,
        name: String,
        url: String,
        isProtected: Boolean,
        onSuccess: (() -> Unit)? = null
    ) {
       /* viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            playerServerRepo.editPlaylist(
                baseUrl = SharedBuildKonfig.PLAYER_SERVER,
                apiKey = SharedBuildKonfig.PLAYER_SERVER_API_KEY,
                playlistId = playlistId,
                name = name,
                url = url,
                isProtected = isProtected,
                onSuccess = { onSuccess?.invoke() },
                onFail = { playlistState = ApiSealed.Error(it.message ?: "Unknown error") }
            )
        }*/
    }

    fun deletePlaylist(
        playlistId: String,
        onSuccess: (() -> Unit)? = null
    ) {
        /*viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            playerServerRepo.deletePlaylist(
                baseUrl = SharedBuildKonfig.PLAYER_SERVER,
                apiKey = SharedBuildKonfig.PLAYER_SERVER_API_KEY,
                playlistId = playlistId,
                onSuccess = {
                    // Optimistically remove from current list
                    val current = playlistState
                    if (current is ApiSealed.Success) {
                        val updated = current.data.playlists.filter { it.id != playlistId }
                        playlistState = ApiSealed.Success(
                            current.data.copy(playlists = updated, total = updated.size)
                        )
                    }
                    onSuccess?.invoke()
                },
                onFail = { playlistState = ApiSealed.Error(it.message ?: "Unknown error") }
            )
        }*/
    }
}